<svg viewBox="0 0 100 100" class="size-full" fill="none">
  @for (segment of segments(); track $index) {
    <path
      [attr.d]="segment.d"
      stroke-width="12"
      stroke-linecap="round"
      class="stroke-current"
      [ngClass]="{
        'text-accent-400': segment.completed,
        'text-accent-900': !segment.completed,
      }" />
  }
</svg>
